export default __webpack_public_path__ + "static/media/Group 12119.2f484d06.png";